import { fpsManager } from '@powerplay/core-minigames'

export const shootingIntroConfig = {

  // ako dlho trva animacia
  moveDuration: 5 * fpsManager.fpsLimit // seconds -> frames

}
